module.exports = __webpack_public_path__ + "static/media/mindset@2x.afeeca19.png";